import { render, staticRenderFns } from "./baseComponent.vue?vue&type=template&id=694862d1&scoped=true&"
import script from "./baseComponent.vue?vue&type=script&lang=js&"
export * from "./baseComponent.vue?vue&type=script&lang=js&"
import style0 from "./baseComponent.vue?vue&type=style&index=0&id=694862d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694862d1",
  null
  
)

export default component.exports